import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Button, Snackbar, withStyles } from '@material-ui/core'
import { navigate } from '@reach/router'

import { canGoToStep2 } from '../../store/booking/selectors'
import { getAppPDV } from '../../store/app/selectors'
import { computeUrl } from './BackButton'

const styles = theme => ({
  root: {
    marginLeft: theme.spacing.unit * 2
  }
})

class ChooseHourButtonBase extends Component {
  state = {
    open: false
  }

  handleClick = () => {
    const { isHourSelected, pdvId } = this.props
    if (!isHourSelected) {
      this.setState({ open: true })
      return
    }

    const url = computeUrl('/form-cliente', pdvId)
    navigate(url)
  }

  handleClose = () => {
    this.setState({ open: false })
  }

  render() {
    const { classes } = this.props
    return (
      <div className={classes.root}>
        <Button variant="contained" color="primary" onClick={this.handleClick}>
          Inserisci i dati
        </Button>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'left'
          }}
          ContentProps={{
            'aria-describedby': 'message-id'
          }}
          open={this.state.open}
          autoHideDuration={2000}
          onClose={this.handleClose}
          message={<span id="message-id">Seleziona data e ora</span>}
        />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  isHourSelected: canGoToStep2(state),
  pdvId: getAppPDV(state)
})

export const ChooseHourButton = withStyles(styles)(ChooseHourButtonBase)
export const LinkedChooseHourButton = connect(mapStateToProps)(ChooseHourButton)
